// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uIEoR","selected":"Menu_selected__IVhHD","brand_box":"Menu_brand_box__Oc5dH","user_box":"Menu_user_box__HnxZC","version_box":"Menu_version_box__zyZM-"};